// import router from '../router'
// import axios from './axios'
// import User from 'src/shared/credential/model/User'
// import { JtechMobx } from 'src/plugins/mobx'
// import { Vue } from 'vue-property-decorator'

export default {
  /**
   * Install the Auth class.
   *
   * Creates a Vue-resource http interceptor to handle automatically adding auth headers
   * and refreshing tokens. Then attaches this object to the global Vue (as Vue.auth).
   *
   * @param {Object} Vue The global Vue.
   * @param {Object} options Any options we want to have in our plugin.
   * @return {void}
   */
  install (Vue) {
    Vue.prototype.$auth = Vue.auth = this
  }
  //   /**
  //    * Login
  //    *
  //    * @param {Object.<string>} creds The username and password for logging in.
  //    * @param {string|null} redirect The name of the Route to redirect to.
  //    * @return {Promise}
  //    */
  //   async _login (creds, callback) {
  //     await axios.post('authentication/authenticate', creds).then(response => {
  //       this._storeToken(response.data)
  //       callback()
  //     }).catch(e => {
  //       throw new Error(e.response.data.errors[0].message)
  //     })
  //   },

  //   /**
  //    * Store tokens
  //    *
  //    * Update the Store store with the access/refresh tokens received from the response from
  //    * the Oauth2 server.
  //    *
  //    * @private
  //    * @param {Response} response Vue-resource Response instance from an OAuth2 server.
  //    *      that contains our tokens.
  //    * @return {void}
  //    */
  //   _storeToken (response) {
  //     return new Promise((resolve, reject) => {
  //       try {
  //         const auth = new Auth(true, response.token)
  //         const user = new User(response.username, response.username)
  //         JtechMobx.getStore().credential.setAuth(auth)
  //         JtechMobx.getStore().credential.setUser(user)
  //         setTimeout(() => {
  //           resolve()
  //         }, 300)
  //       } catch (error) {
  //         reject(error)
  //       }
  //     })
  //   },

  //   /**
  //    * Check if the Vue-resource Response is an invalid token response.
  //    *
  //    * @private
  //    * @param {Response} response The Vue-resource Response instance received from an http call.
  //    * @return {boolean}
  //    */
  //   _isInvalidToken (response) {
  //     const status = response.status
  //     const error = response.data.error

  //     return (
  //       status === 401 && (error === 'invalid_token' || error === 'expired_token')
  //     )
  //   }
  // }

  // export const JtechAuthentication = {
  //   _auth: function () {
  //     return Vue.prototype.$auth
  //   },

  //   login: async function (creds, callback) {
  //     return this._auth()._login(creds, callback)
  //   },

  //   logout: async function () {
  //     this._auth()._logout()
  //   }

}
